import { render } from "./operation-edit.vue?vue&type=template&id=5072eed1&scoped=true"
import script from "./operation-edit.vue?vue&type=script&lang=js"
export * from "./operation-edit.vue?vue&type=script&lang=js"

import "./operation-edit.vue?vue&type=style&index=0&id=5072eed1&scoped=true&lang=less"

import exportComponent from "E:\\Projects\\YDN\\trunk\\zulin-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5072eed1"]])

export default __exports__